<template>
  <div class="product-card-list" id="productCardList">
    <!-- 产品类型标签 -->
    <div class="product-card-tabs" v-if="showTabs">
      <div class="item">
        <span
          :class="productTypeValue == 'hot' ? 'choice' : 'noChoice'"
          :style="productTypeValue == 'hot' ? activeStyle : ''"
          @click="choiceProductType('hot')"
        >
          热门产品</span
        >
        <span
          :class="productTypeValue == '' ? 'choice' : 'noChoice'"
          :style="productTypeValue == '' ? activeStyle : ''"
          @click="choiceProductType('')"
          >全部</span
        >
        <span
          v-for="(item, index) in productType"
          :key="index"
          :ref="item.value + 'tab'"
          :class="productTypeValue == item.value ? 'choice' : 'noChoice'"
          :style="productTypeValue == item.value ? activeStyle : ''"
          class="productType"
          @click="choiceProductType(item.value)"
          >{{ item.label }}</span
        >
      </div>
      <div class="item" v-if="showMoreOptionFlag">
        <span
          v-for="(item, index) in productType2"
          :key="index"
          :ref="item.value + 'tab2'"
          :class="productType2Value == item.value ? 'choice' : 'noChoice'"
          :style="productType2Value == item.value ? activeStyle : ''"
          @click="choiceProductType2(item.value)"
          >{{ item.label }}</span
        >
      </div>
    </div>

    <!-- 产品卡片 -->
    <div class="product-card-content">
      <div
        class="item"
        v-for="(item, index) in productList"
        :key="index"
        @click="toProductDetail(item.id)"
        :style="item.tag ? { paddingTop: '10vw' } : ''"
      >
        <!-- 标签 例如：最新、最热 -->
        <div class="tag" v-show="item.tag">
          <span :style="tagStyle">{{ item.tag }}</span>
        </div>
        <div class="top">
          <div class="left">
            <div class="left-left">
              <img :src="item.productLog" alt="" />
            </div>
            <div class="left-right">
              {{ item.productName }}
            </div>
          </div>
          <div class="right">
            <span :style="btnStyle">立即申请</span>
          </div>
        </div>
        <div
          class="center"
          v-show="item.advantage1 || item.advantage2 || item.advantage3"
        >
          <div v-show="item.advantage1">
            <img
              src="https://static.xchengtech.cn/e61ca91acd4842c9a9664ec461b679e9.png"
              alt=""
            />
            <span>{{ item.advantage1 }}</span>
          </div>
          <div v-show="item.advantage2">
            <img
              src="https://static.xchengtech.cn/f625f3102bab47198bbc5994badf7dba.png"
              alt=""
            />
            <span>{{ item.advantage2 }}</span>
          </div>
          <div v-show="item.advantage3">
            <img
              src="https://static.xchengtech.cn/8fe10c97dfab4f2fbb7c70295bba45c3.png"
              alt=""
            />
            <span>{{ item.advantage3 }}</span>
          </div>
        </div>
        <div class="bottom">
          <div v-show="item.maxLine">
            <span>{{ item.maxLine }}万</span>
            <span class="blueColor" :style="blueStyle">最高额度</span>
          </div>
          <div v-show="item.minLine && item.type == 'FYL'">
            <span>{{ item.minLine }}万起</span>
            <span class="blueColor">授信额度</span>
          </div>
          <div v-show="item.minRate && item.maxRate">
            <span>{{ item.minRate }}%-{{ item.maxRate }}%</span>
            <span>年化利率</span>
          </div>
          <div v-show="!item.minRate && item.maxRate">
            <span>{{ item.maxRate }}%</span>
            <span>最高利率</span>
          </div>
          <div v-show="item.minRate && !item.maxRate">
            <span>{{ item.minRate }}%</span>
            <span>最低利率</span>
          </div>
          <div v-show="item.period">
            <span>{{ item.period }}月</span>
            <span>借款周期</span>
          </div>
        </div>
      </div>
      <van-empty v-show="!productList[0]" description="无符合产品" />
    </div>
  </div>
</template>

<script>
import { getProductList } from "@/api/product.js";
import { getCus as cusGetDict } from "@/api/dictDetail.js";
import { Toast } from "vant";
import Vue from "vue";

Vue.use(Toast);

export default {
  name: "ProductCardList",
  props: {
    // 是否显示顶部筛选标签
    showTabs: {
      type: Boolean,
      default: true,
    },
    // 外部传入的depConfig，用于主题色
    depConfig: {
      type: Object,
      default: () => ({}),
    },
    // 外部指定产品类型
    defaultType: {
      type: String,
      default: "",
    },
    // 是否默认热门
    defaultHot: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      params: {
        type: null,
        status: null,
        productName: null,
        hotFlag: true,
        cityCode: null,
      },
      productType: [],
      productType2: [],
      productTypeValue: "hot",
      productType2Value: "",
      productList: [],
      showMoreOptionFlag: true,
      productTypeForShow: [],
      productType2ForShow: [],
      allProductData: [],
    };
  },
  computed: {
    themeColor() {
      return (this.depConfig && this.depConfig.themeColor) || "#2841c1";
    },
    activeStyle() {
      return this.themeColor ? { background: this.themeColor } : "";
    },
    tagStyle() {
      return this.themeColor ? { background: this.themeColor } : "";
    },
    btnStyle() {
      return this.themeColor
        ? { borderColor: this.themeColor, color: this.themeColor }
        : "";
    },
    blueStyle() {
      return this.themeColor
        ? { color: this.themeColor, borderColor: this.themeColor }
        : "";
    },
  },
  mounted() {
    // 初始化类型
    if (this.defaultType) {
      this.params.type = this.defaultType;
      this.productTypeValue = this.defaultType;
      this.params.hotFlag = false;
    }
    if (!this.defaultHot) {
      this.params.hotFlag = false;
      this.productTypeValue = "";
    }
    this.getProductType();
    this.getProductType2();
  },
  methods: {
    // 获取产品类型
    getProductType() {
      Toast.loading({
        duration: 0,
        forbidClick: true,
        message: "加载中",
      });
      cusGetDict("product_type")
        .then((res) => {
          res.sort((a, b) => {
            return a.sort - b.sort;
          });
          this.productType = res;
          this.getProductList();
          this.getAllProductList();
        })
        .catch((err) => {
          console.log("err", err);
          Toast.clear();
        });
    },
    // 获取产品类型2
    getProductType2() {
      cusGetDict("product_second_type")
        .then((res) => {
          res.sort((a, b) => {
            return a.sort - b.sort;
          });
          this.productType2 = res;
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
    // 获取产品列表
    getProductList() {
      for (let key in this.params) {
        if (!this.params[key]) delete this.params[key];
      }
      Toast.loading({
        duration: 0,
        forbidClick: true,
        message: "加载中",
      });
      getProductList(this.params)
        .then((res) => {
          res.sort((a, b) => {
            return b.sort - a.sort;
          });
          this.productList = res.filter((item) => {
            return item.status == "up";
          });
          if (
            !this.params.type &&
            !this.params.hotFlag &&
            !this.params.secondType
          ) {
            this.allProductData = this.productList;
            this.productTypeIsShow();
            this.productType2IsShow();
          }
          Toast.clear();
        })
        .catch((err) => {
          console.log("err", err);
          Toast.clear();
        });
    },
    // 获取全部产品
    getAllProductList() {
      getProductList()
        .then((res) => {
          res.sort((a, b) => {
            return b.sort - a.sort;
          });
          this.allProductData = res.filter((item) => {
            return item.status == "up";
          });
          this.productTypeIsShow();
          this.productType2IsShow();
        })
        .catch((err) => {
          console.log("err", err);
          Toast.clear();
        });
    },
    // 查看产品详情
    toProductDetail(id) {
      this.$router.push({
        path: "/productDetail",
        query: { productId: id },
      });
    },
    // 判断产品类型标签显示
    productTypeIsShow() {
      this.productTypeForShow = [];
      this.allProductData.forEach((item) => {
        if (item.type && item.status == "up") {
          if (this.productTypeForShow.indexOf(item.type) < 0) {
            this.productTypeForShow.push(item.type);
          }
        }
      });
      this.productType.forEach((item) => {
        if (this.$refs[item.value + "tab"]) {
          if (this.productTypeForShow.indexOf(item.value) > -1) {
            this.$refs[item.value + "tab"][0].style.display = "block";
          } else {
            this.$refs[item.value + "tab"][0].style.display = "none";
          }
        }
      });
    },
    // 判断二级标签显示
    productType2IsShow() {
      this.productType2ForShow = [];
      this.allProductData.forEach((item) => {
        if (item.secondType && item.status == "up") {
          if (this.productType2ForShow.indexOf(item.secondType) < 0) {
            this.productType2ForShow.push(item.secondType);
          }
        }
      });
      if (this.productType2ForShow.length == 0) {
        this.showMoreOptionFlag = false;
      }
      this.productType2.forEach((item) => {
        if (this.$refs[item.value + "tab2"]) {
          if (this.productType2ForShow.indexOf(item.value) > -1) {
            this.$refs[item.value + "tab2"][0].style.display = "block";
          } else {
            this.$refs[item.value + "tab2"][0].style.display = "none";
          }
        }
      });
    },
    scrollToDiv(divId) {
      var div = document.getElementById(divId);
      div.scrollIntoView({ behavior: "smooth", block: "start" });
    },
    // 选择产品类型
    choiceProductType(value) {
      if (this.productTypeValue != value) {
        if (value == "hot") {
          this.params.hotFlag = true;
          this.params.type = "";
        } else {
          this.params.hotFlag = false;
          this.params.type = value;
        }
        this.productTypeValue = value;
        this.productType2Value = "";
        this.params.secondType = "";
        this.scrollToDiv("productCardList");
        this.getProductList();
      }
    },
    // 选择二级标签
    choiceProductType2(value) {
      if (this.productType2Value != value) {
        this.productType2Value = value;
        this.params.secondType = value;
        this.params.hotFlag = false;
        this.params.type = "";
        this.productTypeValue = null;
        this.scrollToDiv("productCardList");
        this.getProductList();
      }
    },
    // 外部调用的搜索方法
    search(params) {
      if (params) {
        Object.assign(this.params, params);
      }
      this.scrollToDiv("productCardList");
      this.getProductList();
    },
    // 刷新列表
    refresh() {
      this.getProductList();
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=Outfit:wght@500;700&display=swap");

.product-card-list {
  background-color: #f7f7f9;
}

/* 标签栏 */
.product-card-tabs {
  position: sticky;
  top: 0;
  left: 0;
  padding: 0 4vw;
  padding-top: 4vw;
  background-color: #f7f7f9;
  z-index: 99;
}

.product-card-tabs .item {
  display: flex;
  width: 100%;
  gap: 3vw;
  overflow-x: auto;
  padding-bottom: 4vw;
}

.product-card-tabs .item::-webkit-scrollbar {
  display: none;
}

.product-card-tabs .item span {
  border-radius: 35px;
  padding: 2vw 4vw;
  box-sizing: border-box;
  text-align: center;
  font-size: 3.4vw;
  white-space: nowrap;
  border: 1px solid #eee;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
}

.productType {
  display: none;
}

.choice {
  background: #2841c1;
  font-weight: 500;
  color: white;
}

.noChoice {
  background: white;
  color: #667799;
  font-weight: 500;
}

/* 产品卡片 */
.product-card-content {
  display: grid;
  gap: 4vw;
  padding: 0 4vw 21vw 4vw;
}

.product-card-content .item {
  position: relative;
  padding: 5vw;
  background-color: #fff;
  border-radius: 20px;
  box-shadow: 0 4px 12px -2px rgba(26, 60, 120, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.02);
}

.product-card-content .item .tag {
  position: absolute;
  top: 0;
  left: 5vw;
}

.product-card-content .item .tag span {
  display: inline-block;
  background-color: #2841c1;
  font-size: 3.6vw;
  padding: 0.6vw 2.6vw;
  color: white;
  border-radius: 0 0 8px 8px;
  font-weight: 600;
}

.product-card-content .item .top {
  display: grid;
  grid-template-columns: auto 24vw;
  align-items: center;
  padding-bottom: 4vw;
}

.product-card-content .item .top .left {
  display: flex;
  align-items: center;
}

.product-card-content .item .top .left .left-left {
  padding-right: 3vw;
}

.product-card-content .item .top .left .left-left img {
  display: block;
  width: 12vw;
}

.product-card-content .item .top .left .left-right {
  display: grid;
  align-items: center;
  gap: 2vw;
  font-size: 4.6vw;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 700;
}

.product-card-content .item .center {
  width: 100%;
  display: flex;
  gap: 2vw;
  padding-bottom: 4vw;
}

.product-card-content .item .center div {
  display: flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 6px;
  gap: 1vw;
  font-size: 3vw;
  font-weight: 600;
}

.product-card-content .item .center div img {
  display: block;
  height: 2.4vw;
}

.product-card-content .item .center div:nth-of-type(1) {
  color: #10b981;
  background: #ecfdf5;
}

.product-card-content .item .center div:nth-of-type(2) {
  color: #3b82f6;
  background: #eff6ff;
}

.product-card-content .item .center div:nth-of-type(3) {
  background-color: #ffefdf;
  color: #fd910a;
}

.product-card-content .item .top .right span {
  display: block;
  border-radius: 35px;
  padding: 2vw 4vw;
  border: 1px solid #2841c1;
  color: #2841c1;
  text-align: center;
  font-weight: 600;
}

.product-card-content .item .bottom {
  border-top: 1px solid #efefef;
  padding-top: 4vw;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  justify-content: center;
  text-align: center;
  gap: 4vw;
}

.product-card-content .item .bottom div {
  display: grid;
  gap: 1vw;
}

.product-card-content .item .bottom div span:nth-of-type(1) {
  font-size: 4.6vw;
  font-weight: 700;
  color: #1b2232;
  font-family: "Outfit", sans-serif;
}

.product-card-content .item .bottom div span:nth-of-type(2) {
  font-size: 3vw;
  color: #667799;
}

.blueColor {
  color: #2841c1;
}
</style>



// WEBPACK FOOTER //
// src/view/productList/module/ProductCardList.vue